import {Inject, Injectable} from '@angular/core';
import {ITokenService} from './token.interface';
import {BehaviorSubject, Observable} from 'rxjs';
import {ITokenModel} from './itoken.model';
import {DA_STORE_TOKEN, IStore} from './istore.interface';
import {share} from 'rxjs/operators';

const STORE_KEY = 'token';

@Injectable({
  providedIn: 'root'
})
export class TokenService implements ITokenService {

  constructor(@Inject(DA_STORE_TOKEN) private store: IStore) {
  }

  private change$: BehaviorSubject<ITokenModel> = new BehaviorSubject<ITokenModel>(null);

  set(data: ITokenModel): boolean {
    this.change$.next(data);
    return this.store.set(STORE_KEY, data);
  }

  // tslint:disable-next-line:no-any
  get(type?: any);
  get<T extends ITokenModel>(type?: { new(): T }): T {
    const data = this.store.get(STORE_KEY);
    return type ? (Object.assign(new type(), data) as T) : (data as T);
  }

  clear() {
    this.change$.next(null);
    this.store.remove(STORE_KEY);
  }

  change(): Observable<ITokenModel> {
    return this.change$.pipe(share());
  }
}

